import script from "./TagDueDateMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./TagDueDateMenu.vue?vue&type=script&setup=true&lang=js"

import "./TagDueDateMenu.vue?vue&type=style&index=0&id=7639e26e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7639e26e"]])

export default __exports__